import { createContext, Dispatch, PropsWithChildren, ReactElement, SetStateAction, useContext, useState } from 'react'

interface SalesReportStatistics {
  totalSalesValue: string
  totalPaidValue: string
  totalUnpaidValue: string
}

interface ContextState extends Partial<SalesReportStatistics> {
  setSalesReportStatistics: Dispatch<SetStateAction<SalesReportStatistics | undefined>>
}

const SalesReportContext = createContext<ContextState | undefined>(undefined)

export const SalesReportContextProvider = ({ children }: PropsWithChildren): ReactElement => {
  const [salesReportStatistics, setSalesReportStatistics] = useState<SalesReportStatistics>()

  return (
    <SalesReportContext.Provider value={{ ...salesReportStatistics, setSalesReportStatistics }}>
      {children}
    </SalesReportContext.Provider>
  )
}

export const useSalesReport = () => {
  const context = useContext(SalesReportContext)

  if (!context) {
    throw new Error('SalesReportContextProvider is missing in the module!')
  }

  return context
}
